import './assets/loader.css';

const Loader = () => (
  <div className='flex h-screen w-screen items-center justify-center'>
    <div className='spinner' />
  </div>
);

export default Loader;
